import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAnalyticsService } from 'services/analyticsService';
import type { AnalyticsOrigin } from 'services/types/analytics';

import { useIsAndroid, useIsiOS } from '../../../hooks/useDeviceInfo';
import { useKioskManager } from '../../../hooks/useKioskManager';
import { useNetworkManager } from '../../../hooks/useNetworkManager';
import ButtonStyled from '../button/Button';
import { CallToActionModal } from '../callToActionModal/CallToActionModal';
import TextButton from '../textButton/TextButton';

interface CTAButtonProps {
  useTextButton?: boolean;
  origin: string;
}

export const CallToActionButton: React.FC<CTAButtonProps> = ({
  useTextButton = false,
  origin,
}) => {
  const analyticsService = useMemo(() => getAnalyticsService(), []);
  const [showCallToActionModal, setShowCallToActionModal] = useState(false);
  const { t } = useTranslation('common');
  const { kioskMode } = useKioskManager();
  const { brandingData } = useNetworkManager();
  const isIos = useIsiOS();
  const isAndroid = useIsAndroid();

  const appLink = useMemo(
    () => (brandingData ? brandingData[0].install_app_cta_url : ''),
    [brandingData],
  );

  const goToLink = () => {
    window.location.href = appLink;
  };
  const handleCTAClick = () => {
    analyticsService?.track(analyticsService.events.CTAModal, {
      origin: (origin || 'unknown') as AnalyticsOrigin,
    });
    if (!kioskMode) {
      if (isIos || isAndroid) {
        // Go to link depending on Mobile OS type
        goToLink();
      } else {
        //kioskMode: False isIos:False isAndroid:False - Must be desktop
        setShowCallToActionModal(true);
      }
    } else {
      setShowCallToActionModal(true);
    }
  };

  return (
    <>
      {useTextButton ? (
        <TextButton
          side="none"
          onClick={handleCTAClick}
          label={t('tutorial.step3.link')}
          capitalize
        />
      ) : (
        <ButtonStyled onClick={handleCTAClick} variant={'contained'} uppercase>
          {t('header.getMobileApp')}
        </ButtonStyled>
      )}
      <CallToActionModal
        isOpen={showCallToActionModal}
        onCtaClick={goToLink}
        onClose={() => setShowCallToActionModal(false)}
      />
    </>
  );
};
